ready().then(function() {
    /**
     * it's needed to do a check if a copyright sign already exists in the source, otherwise we have to add one
     * For now I can't find any other html-copyright signs
     */

    const photographer = $('.photographer');
    if(photographer.lenght > 0) {
        if (photographer.html().indexOf('©') === -1 ) {
            photographer.prepend('© ');
        }
    }
});